import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';
import { Invitation } from '../types/invitation';

class InvitationService {
  /**
   * Get all invitations sent by a specific coach
   */
  async getInvitationsByCoach(coachId: string | undefined): Promise<Invitation[]> {
    if (!coachId) return [];

    try {
      const invitationsRef = collection(db, 'invitations');
      const q = query(
        invitationsRef,
        where('coachId', '==', coachId)      
    );
    

      const querySnapshot = await getDocs(q);

      return querySnapshot.docs.map(doc => {
        const data = doc.data();
        return {
          id: doc.id,
          coachId: data.coachId,
          athleteEmail: data.athleteEmail,
          status: data.status,
          createdAt: data.createdAt?.toDate?.() || data.createdAt,
          message: data.message
        } as Invitation;
      });
    } catch (error) {
      console.error('Error fetching invitations:', error);
      return [];
    }
  }

  /**
   * Get all invitations for an organisation
   */
  async getInvitationsByOrg(orgId: string): Promise<Invitation[]> {
    if (!orgId) return [];

    try {
      const q = query(
        collection(db, 'invitations'),
        where('orgId', '==', orgId)
      );
      const snap = await getDocs(q);
      return snap.docs.map(d => {
        const data = d.data();
        return {
          id: d.id,
          coachId: data.coachId,
          athleteEmail: data.athleteEmail,
          status: data.status,
          createdAt: data.createdAt?.toDate?.() || data.createdAt,
          message: data.message,
        } as Invitation;
      });
    } catch (error) {
      console.error('Error fetching org invitations:', error);
      return [];
    }
  }
}

export const invitationService = new InvitationService();
